// Public site URL used for canonical/OG/JSON-LD SEO tags.
// Always points to the production domain (regardless of preview vs prod runtime),
// because SEO tags must reference a single canonical origin.
export const SITE_URL = (
  process.env.REACT_APP_SITE_URL || "https://carroassistenzaroma.com"
).replace(/\/+$/, "");
